import { useLazyQuery } from "@apollo/client";

import {
  ILatestHealthStatusResponse,
  IMedicalRecordPdf,
  IMedicalRecordPdfResponse,
  IRabiesCertificatePdfResponse,
  IRabiesVaccinationListResponse,
} from "./medical-history.interface";
import {
  GET_LATEST_HEALTH_STATUS,
  GET_MEDICAL_RECORD_PDF,
  GET_RABIES_CERTIFICATE_PDF,
  GET_RABIES_VACCINATION_LIST,
} from "./medical-history.query";

export const useLatestHealthStatus = () => {
  const [getHealthStatus, { data, loading, called, error }] =
    useLazyQuery<ILatestHealthStatusResponse>(GET_LATEST_HEALTH_STATUS, {
      fetchPolicy: "cache-and-network",
    });

  const fetchHealthStatus = (animalId: string) => {
    getHealthStatus({ variables: { animalId } });
  };

  return {
    fetchHealthStatus,
    healthStatus: data?.latestHealthStatus ?? null,
    loading,
    called,
    error,
  };
};

export const useMedicalRecordPdf = () => {
  const [getPdf, { loading, error }] = useLazyQuery<IMedicalRecordPdfResponse>(
    GET_MEDICAL_RECORD_PDF,
    {
      fetchPolicy: "network-only",
    },
  );

  const fetchMedicalRecordPdf = async (
    animalId: string,
  ): Promise<IMedicalRecordPdf | null> => {
    const { data } = await getPdf({ variables: { animalId } });

    return data?.medicalRecordDetailPdf ?? null;
  };

  return {
    fetchMedicalRecordPdf,
    downloadLoading: loading,
    error,
  };
};

export const useRabiesVaccinations = () => {
  const [getVaccinations, { data, loading, called, error }] =
    useLazyQuery<IRabiesVaccinationListResponse>(GET_RABIES_VACCINATION_LIST, {
      fetchPolicy: "cache-and-network",
    });

  const fetchRabiesVaccinations = (animalId: string) => {
    getVaccinations({ variables: { animalId } });
  };

  return {
    fetchRabiesVaccinations,
    vaccinations: data?.rabiesVaccinationList ?? null,
    loading,
    called,
    error,
  };
};

export const useRabiesCertificatePdf = () => {
  const [getPdf, { loading, error }] =
    useLazyQuery<IRabiesCertificatePdfResponse>(GET_RABIES_CERTIFICATE_PDF, {
      fetchPolicy: "network-only",
    });

  const fetchRabiesCertificatePdf = async (
    animalId: string,
  ): Promise<IMedicalRecordPdf | null> => {
    const { data } = await getPdf({ variables: { animalId } });

    return data?.rabiesVaccinationCertificatePdf ?? null;
  };

  return {
    fetchRabiesCertificatePdf,
    downloadLoading: loading,
    error,
  };
};
